var React = require('react');

function LockGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#32E2B9","fillRule":"nonzero","d":"M13.458 6.333h-.791V4.758A4.711 4.711 0 0 0 8.007 0h-.13a4.716 4.716 0 0 0-4.71 4.665v1.668h-.792A2.375 2.375 0 0 0 0 8.708v7.917A2.375 2.375 0 0 0 2.375 19h11.083a2.375 2.375 0 0 0 2.375-2.375V8.708a2.375 2.375 0 0 0-2.375-2.375zm-4.75 9.5H7.125v-1.729a2.375 2.375 0 1 1 1.583 0v1.73-.001zm2.375-9.5H4.75V4.68a3.132 3.132 0 0 1 3.127-3.097h.11a3.127 3.127 0 0 1 3.096 3.167v1.583z"}));
}

LockGreen.defaultProps = {"width":"16","height":"19","viewBox":"0 0 16 19"};

module.exports = LockGreen;

LockGreen.default = LockGreen;
